export class MirrorController {
  /* @ngInject */
  constructor($state, $stateParams, previousState) {
    this.$state = $state;

    if($stateParams.extraParam) {
      // work around needed to add params to the previous state.
      // needed since '$state.reload()' doesn't seem to
      // recall the controller, even though here they say it was fixed https://github.com/angular-ui/ui-router/issues/582
      let arr = $stateParams.extraParam.split('--');
      previousState.params[arr[0]] = arr[1];
    }
    previousState.name && this.$state.go(previousState.name, previousState.params);
  }
}


/** WEBPACK FOOTER **
 ** ./src/common/appLifeCycle/stateMirror.js
 **/